// VenueComparisonCard — the panel-less body (stacked bar + summary table) the
// dispatch registers for viz:"venue_comparison". The page wraps the same pieces
// in the collapsible VenueComparisonPanel; this exists so the generic
// dispatch-by-viz registry is complete (renderReports can render it if the
// report ever arrives in a report list).

import { resolveVenueComparisonWindow } from '../../../../providers/options-flow/options-flow.helpers';
import { VenueComparisonReport } from '../../../../providers/options-flow/types';
import { VenueMixChart } from '../venue-mix-chart';
import { VenueComparisonTable } from '../venue-comparison-table';

export const VenueComparisonCard = ({ report }: { report: VenueComparisonReport }) => {
  // No page context here — resolve the 24h slice (falls back to the first
  // available window). The page wraps the windowed panel with the live window.
  const slice = resolveVenueComparisonWindow(report, '24h');
  if (!slice) return null;
  return (
    <>
      {(slice.series?.length ?? 0) >= 2 && slice.series && (
        <VenueMixChart
          series={slice.series}
          measures={report.measures}
          granularity={slice.granularity}
        />
      )}
      {slice.summary.length > 0 && <VenueComparisonTable summary={slice.summary} />}
    </>
  );
};
